// Split after visibility/filter/sort rules, but before pagination of rendered rows.
// Search stays a single list so pinning never hides or duplicates a result.
export function partitionSidebarChats(items, isSearching = false) {
  if (isSearching) return { pinnedItems: [], recentItems: items };
  const pinnedItems = [];
  const recentItems = [];
  for (const item of items) (item.isPinned ? pinnedItems : recentItems).push(item);
  return { pinnedItems, recentItems };
}
